import { Button, Center, EmptyState, Table } from '@mantine/core';
import { IconPlus, IconTag } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { ReasonListItem } from 'modules/Tasks';
import { useLoadReasons } from '~/modules/Settings/Variables/Reasons/api';

type Props = {
  onCreate: () => void;
  actionLabel: string;
  isActive: boolean;
};

export const Reasons = ({ onCreate, actionLabel, isActive }: Props) => {
  const { t } = useTranslation();

  const { reasons, isReasonsInitialLoading } = useLoadReasons();

  if (reasons.data.length === 0 && !isReasonsInitialLoading) {
    return (
      <Center my="xl" w="100%">
        <EmptyState
          icon={<IconTag size={48} stroke={1.5} />}
          title={t(i18nKeys.SETTINGS.CUSTOMIZATION.EMPTY_STATE.REASONS_TITLE)}
          description={t(i18nKeys.SETTINGS.CUSTOMIZATION.EMPTY_STATE.REASONS_DESCRIPTION)}
        >
          <EmptyState.Actions>
            <Button
              disabled={!isActive}
              rightSection={<IconPlus size={20} stroke={1.5} />}
              onClick={() => isActive && onCreate()}
            >
              {actionLabel}
            </Button>
          </EmptyState.Actions>
        </EmptyState>
      </Center>
    );
  }

  return (
    <Table verticalSpacing="xs" striped highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>ID</Table.Th>
          <Table.Th>{t(i18nKeys.NAME)}</Table.Th>
          <Table.Th>{t(i18nKeys.FORM.TYPE)}</Table.Th>
          <Table.Th>{t(i18nKeys.CREATION)}</Table.Th>
          <Table.Th w={100}>{t(i18nKeys.FORM.ACTIONS)}</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {reasons.data.map(item => (
          <ReasonListItem key={item.id} item={item} />
        ))}
      </Table.Tbody>
    </Table>
  );
};
